/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Col, Row } from "@/utils/bootstrap";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { IBranch } from "@/api/AppApi/services/company/interfaces/ICompany";
import { getBranchIdCookie } from "@/utils/functions/cookieOperations";
import NextImage from "@/app/components/lib/NextImage";
import InputErrorMsg from "@/app/components/common-form-builder/form-builder-helpers/InputErrorMsg";
import { useTranslation } from "@/hooks/localization/useTranslations";
import BranchDetailsPopup from "../../checkout-branches/branch-helpers/BranchDetailsPopup";
import RadioHook from "../../RadioHook";
import { receivingBranchAtom } from "@/hooks/receivingHeaderAtom";
import { useAtom } from "jotai";

interface Props {
  form: UseFormReturn<FieldValues, any>;
  fieldName: string;
  className?: string;
  mobile: boolean;
  branches: IBranch[];
}
const DeliveryBranches: React.FC<Props> = ({ form, fieldName, branches }) => {
  const t = useTranslation();
  const [, setreceivingBranch] = useAtom(receivingBranchAtom);
  const [branchToViewDetails, setBranchToViewDetails] =
    useState<IBranch | null>(null);

  useEffect(() => {
    form.register(fieldName, {
      required: t.you_must_choose_the_delivery_branch,
    });
  }, [fieldName]);
  useEffect(() => {
    if (branches.length < 1) {
      form.setValue(fieldName, null);
      return;
    } else {
      if (
        form.getValues(fieldName) &&
        branches.map((branch) => branch.id).includes(+form.getValues(fieldName))
      )
        return;
      const initialBranchId = branches
        .map((branch) => branch.id)
        .includes(+getBranchIdCookie())
        ? +getBranchIdCookie()
        : branches[0]?.id;
      const initialBranch = branches.find(
        (branch) => branch.id === initialBranchId,
      );
      setreceivingBranch(initialBranch!);
      form.setValue(fieldName, initialBranchId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branches]);
  return (
    <>
      {branchToViewDetails ? (
        <BranchDetailsPopup
          onCloseInPopuUp={() => {
            setBranchToViewDetails(null);
          }}
          inPopUp
          branch={branchToViewDetails}
          show={!!branchToViewDetails}
          setShow={() => setBranchToViewDetails(null)}
        />
      ) : (
        <div className="branches">
          {branches?.map((branch, key) => (
            <div key={key} className="branch">
              <Row className="m-0 name" style={{ gap: 4 }}>
                <Col className="p-0 col-auto ">
                  <RadioHook
                    form={form}
                    option={{ id: branch.id, value: branch.name }}
                    fieldName={fieldName}
                    onOptionChange={() => {
                      setreceivingBranch(branch!);
                    }}
                    isRequired
                  />
                </Col>
                <Col className="p-0">
                  <NextImage
                    src={branch.thumbnail_url ?? branch.image_url}
                    alt="pay"
                    width={20}
                    height={14}
                    objectFit="cover"
                  />
                </Col>
              </Row>
              <div className="address">{branch.address ?? t.noAddress}</div>
              <div
                className="view-details"
                onClick={() => {
                  setBranchToViewDetails(branch);
                }}
              >
                {t.view_details}
              </div>
            </div>
          ))}

          {form.formState.errors[fieldName] && (
            <InputErrorMsg
              errorMsg={form.formState.errors[fieldName]?.message as string}
            />
          )}
        </div>
      )}
    </>
  );
};

export default DeliveryBranches;
